<template>
    <div>
        <h1 class="main-title">Obchodně techničtí zástupci</h1>
        <contact-tabs/>
        <contact-tab-content/>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {SECTION_SALES_REPREZENTATIVES} from './constants';
    import {SET_SECTION_TYPE} from './action';
    import {NAMESPACE} from './store';
    import ContactTabs from './Tabs';
    import ContactTabContent from './TabContent';

    export default {
        name: 'ContactSalesRepresentativeContainer',
        components: {
            ContactTabContent,
            ContactTabs
        },
        mounted() {
            this[SET_SECTION_TYPE](SECTION_SALES_REPREZENTATIVES);
        },
        methods: {
            ...mapActions(NAMESPACE, [SET_SECTION_TYPE]),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/SalesRepresentativeContainer.vue